// extracted by mini-css-extract-plugin
export default {"submenuItemList":"SubmenuItemList_submenuItemList__K4WTE","submenuItem":"SubmenuItemList_submenuItem__i1FJm"};